import React, { useEffect, useReducer, useState, useContext } from "react";
import {
  AppContext,
  ProductsContext,
} from "../../../utils/stateHandlers/contexts";
import { productReducer } from "../../../utils/stateHandlers/reducers";
import states from "../../../utils/stateHandlers/initialStates";
import { Mobile, Default } from "../../../utils/deviceHelpers";
import { Link as DomLink } from "react-router-dom";
import { storage } from "../../../utils";
import api from "../../../utils/api";
import qs from "qs";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import Select from "@mui/material/Select";
import toast from "react-hot-toast";
import { functions, constants } from "../../../utils";
import { Grid, Divider, Container, Stack } from "@mui/material";
import TechnicalArticles from "../components/TechnicalArticles";
import CustomerTestimonials from "../components/CustomerTestimonials";
import HorizontalScrollList from "../components/HorizontalScrollList";
import DetailTable from "../components/DetailTable";
import SpecialInstructions from "../components/SpecialInstructions";
import Typography from "@mui/material/Typography";
import Backdrop from "@mui/material/Backdrop";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from "@mui/material/CircularProgress";
import _ from "lodash";
import TreatmentField from "../components/TreatmentField";
import Price from "../components/Price";
import CharmsImage from "../../../assets/images/CHM_S_XLG.png";
import FillerImage from "../../../assets/images/Filler-Harmony-8-1-22.gif";
import Material from "../components/productFields/Material";
import Quantity from "../components/productFields/Quantity";
import Thickness from "../components/productFields/Thickness";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export default function Charms(props) {
  const { authToken } = useContext(AppContext);
  const [productState, productDispatch] = useReducer(
    productReducer,
    states.initialProductState
  );
  const {
    pageLoaded,
    productInfo,
    productDetails,
    icons,
    productFields,
    productTreatments,
    compatibleProducts,
    relatedProducts,
    metalColumns,
    strapiChart,
    TopText,
    BottomText,
    ChartSizeSmall,
    charmDimension,
    advertisement,
  } = productState;
  const [charmShape, setCharmShape] = useState(null);
  const [charmShapeOptions, setCharmShapeOptions] = useState();
  const [filter, setFilter] = useState({});
  const [charmStyle, setCharmStyle] = useState(null);
  const [charmStyles, setCharmStyles] = useState();
  const [styleLoaded, setStyleLoaded] = useState(false);

  const productGroup = props.ProductGroup;
  const frontImageUrl = constants.CMS_FRONT_IMAGE_URL;

  function createProductDefaults(product) {
    setStyleLoaded(false);
    var productDefaults = {};
    productDefaults = {
      ...productDefaults,
      product: product.product,
      description: product.description,
      treatments: "",
      dimension: `${product.dimension}x20GA`,
    };
    productDispatch({
      type: "setStyle",
      payload: product,
    });
    productDispatch({
      type: "setProductDefaults",
      field: "product",
      payload: product.product,
    });
    productDispatch({
      type: "setProductDefaults",
      field: "description",
      payload: product.description,
    });
    productDispatch({
      type: "setProductDefaults",
      field: "treatments",
      payload: "",
    });
    productDispatch({
      type: "setProductDefaults",
      field: "dimension",
      payload: `${product.dimension}x20GA`,
    });
    _.forEach(product.fields, function (field) {
      if (field.name !== "dimension") {
        if (field.template === "field_with_units") {
          productDispatch({
            type: "setProductDefaults",
            field: field.name,
            payload: field.default,
          });
          productDispatch({
            type: "setProductDefaults",
            field: `${field.name}_unit`,
            payload: field.default_unit,
          });
          productDefaults = {
            ...productDefaults,
            [field.name]: field.default,
            [`${field.name}_unit`]: field.default_unit,
          };
        } else {
          productDispatch({
            type: "setProductDefaults",
            field: field.name,
            payload: field.default,
          });
          productDefaults = {
            ...productDefaults,
            [field.name]: field.default,
          };
        }
      }
    });
    if (authToken) {
      getInitialPrice(productDefaults);
    }
  }

  function makeInitialQueryString(productDefaults) {
    const query = qs.stringify({
      product: productDefaults.product,
      dimension: productDefaults.dimension,
      quantity: productDefaults.quantity,
      quantity_unit: productDefaults.quantity_unit,
      material: productDefaults.material,
      carat_size: productDefaults.carat_size,
      message: productDefaults.message,
      finger_size: productDefaults.finger_size,
      treatments: "",
    });
    return query;
  }

  function getInitialPrice(productDefaults) {
    const query = makeInitialQueryString(productDefaults);
    api.fetch(`quickorder/price?${query}`).then((response) => {
      if (response.isAxiosError) {
        const errorMessage = [];
        _.forEach(response.response.data.errors, function (error) {
          errorMessage.push(error);
        });
        console.log(errorMessage);
        toast.error(
          `There was an error processing your request. ${_.toString(
            errorMessage
          )}`
        );
        productDispatch({
          type: "setMessage",
          payload: {
            message: _.values(response.response.data.errors),
            type: "error",
          },
        });
      } else {
        productDispatch({ type: "setPrice", payload: response.data });
        productDispatch({ type: "setPriceLoaded", payload: true });
        setStyleLoaded(true);
      }
    });
  }

  function setTreatmentsString() {
    const treatmentsList = _.map(productInfo.treatments, function (treatment) {
      return treatment.value;
    });
    return _.join(treatmentsList, " ");
  }

  function makeQueryString() {
    const query = qs.stringify({
      product: productInfo.product,
      dimension: `${charmDimension}x${productInfo.thickness}${productInfo.thickness_unit}`,
      quantity: productInfo.quantity,
      quantity_unit: productInfo.quantity_unit,
      material: productInfo.material,
      carat_size: productInfo.carat_size,
      message: productInfo.message,
      finger_size: productInfo.finger_size,
      treatments: setTreatmentsString(),
    });
    return query;
  }

  function getUpdatedPrice(newQueryString) {
    api.fetch(`quickorder/price?${newQueryString}`).then((response) => {
      if (response.isAxiosError) {
        const errorMessage = [];
        _.forEach(response.response.data.errors, function (error) {
          errorMessage.push(error);
        });
        console.log(errorMessage);
        toast.error(
          `There was an error processing your request. ${_.toString(
            errorMessage
          )}`
        );
        productDispatch({
          type: "setMessage",
          payload: {
            message: _.values(response.response.data.errors),
            type: "error",
          },
        });
        productDispatch({ type: "setPriceLoaded", payload: true });
      } else {
        updateFields(response.data.fields);
        productDispatch({
          type: "setNewTreatmentFields",
          payload: response.data.treatments,
        });
        productDispatch({ type: "updatePrice", payload: response.data });
        productDispatch({
          type: "setMessage",
          payload: { message: null, type: null },
        });
        productDispatch({ type: "setPriceLoaded", payload: true });
      }
    });
  }

  function updateFields(fields) {
    const newFields = [];
    _.find(productFields, function (field) {
      newFields.push(
        field.name === "material" ||
          field.name === "length" ||
          field.name === "width" ||
          field.name === "thickness" ||
          field.name === "outer_diameter" ||
          field.name === "inner_diameter"
          ? field
          : null
      );
    });
    _.forEach(fields, function (field) {
      newFields.push(
        field.name === "quantity"
          ? field
          : field.name === "dimension"
          ? field
          : field.name === "quantity.pieces"
          ? field
          : field.name === "quantity.length"
          ? field
          : field.name === "carat_size"
          ? field
          : field.name === "finger_size"
          ? field
          : null
      );
    });
    const filteredFields = _.uniq(_.without(newFields, null));
    const sortedFields = sortFields(filteredFields);
    productDispatch({
      type: "setNewFields",
      payload: sortedFields,
    });
  }

  function sortFields(fields) {
    const newSortedFields = [];
    _.forEach(fields, function (field) {
      const newField = _.assignIn(
        {
          SortOrder:
            field.name === "material"
              ? 1
              : field.name === "dimension"
              ? 2
              : field.name === "carat_size"
              ? 3
              : field.name === "finger_size"
              ? 4
              : field.name === "quantity"
              ? 5
              : field.name === "outer_diameter"
              ? 10
              : field.name === "inner_diameter"
              ? 11
              : field.name === "quantity.pieces"
              ? 12
              : field.name === "quantity.length"
              ? 13
              : field.name === "length"
              ? 20
              : field.name === "width"
              ? 21
              : field.name === "thickness"
              ? 22
              : 100,
        },
        field
      );
      newSortedFields.push(newField);
    });
    return _.sortBy(newSortedFields, "SortOrder");
  }

  useEffect(() => {
    api
      .post(`catalog/items`, {
        category: "Charms",
        filters: {},
      })
      .then((res) => {
        const shapes = _.find(res.data.groups, function (filter) {
          return filter.name === "CharmShape";
        });
        const sortedShapes = _.sortBy(shapes.values, ["label"]);
        setCharmShapeOptions(sortedShapes);
      });
    productDispatch({ type: "setPageLoaded", payload: true });
    //productDispatch({ type: "setPriceLoaded", payload: true });
    //productDispatch({ type: "setProductGroup", payload: props.ProductGroup });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params.ProductStyleCode]);

  useEffect(() => {
    const strapiId = 44;
    const query = qs.stringify({
      populate: {
        left: {
          populate: "*",
        },
        middle: {
          populate: "*",
        },
        right: {
          populate: "*",
        },
        chart: {
          populate: "*",
        },
      },
    });
    api
      .fetchStrapi(`/product-details-charts/${strapiId}?${query}`)
      .then((response) => {
        productDispatch({
          type: "setStrapi",
          payload: {
            left: response.data.data.attributes.left,
            middle: response.data.data.attributes.middle,
            right: response.data.data.attributes.right,
            chart: response.data.data.attributes.chart,
            ChartSizeSmall: response.data.data.attributes.ChartSizeSmall,
            TopText: response.data.data.attributes.TopText,
            BottomText: response.data.data.attributes.BottomText,
          },
        });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isMill, props.match.params.ProductStyleCode]);

  //advertisements from Strapi
  useEffect(() => {
    const query = qs.stringify({
      populate: {
        One: {
          populate: "*",
        },
        Two: {
          populate: "*",
        },
        Three: {
          populate: "*",
        },
        Four: {
          populate: "*",
        },
        Five: {
          populate: "*",
        },
      },
    });
    api.fetchStrapi(`/detail-page-ad?${query}`).then((response) => {
      const randomNum = Math.floor(Math.random() * 5);
      const randomAd =
        randomNum === 1
          ? response.data.data.attributes.One.data.attributes
          : randomNum === 2
          ? response.data.data.attributes.Two.data.attributes
          : randomNum === 3
          ? response.data.data.attributes.Three.data.attributes
          : randomNum === 4
          ? response.data.data.attributes.Four.data.attributes
          : response.data.data.attributes.Five.data.attributes;
      productDispatch({
        type: "setPageAd",
        payload: randomAd,
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params.ProductStyleCode]);

  useEffect(() => {
    api
      .post(`catalog/items`, {
        category: "Charms",
        filters: filter,
      })
      .then((res) => {
        const array = [];
        _.map(res.data.items, function (style) {
          const formattedOption = {
            label: style.description,
            value: style.style,
          };
          array.push(formattedOption);
        });
        setCharmStyles(array);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  useEffect(() => {
    if (charmStyle !== "None" && charmStyle !== null) {
      productDispatch({ type: "setPriceLoaded", payload: false });
      api.fetch(`quickorder/form?style=${charmStyle}`).then((response) => {
        if (response.isAxiosError) {
          const errorMessage = [];
          _.forEach(response.response.data.errors, function (error) {
            errorMessage.push(error);
          });
          console.log(errorMessage);
          toast.error(
            `There was an error processing your request. ${_.toString(
              errorMessage
            )}`
          );
        } else {
          createProductDefaults(response.data);
          functions.storeRecentlyViewed(response.data);
          productDispatch({
            type: "setCharmDimension",
            payload: response.data.dimension,
          });
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [charmStyle]);

  useEffect(() => {
    if (authToken && pageLoaded && styleLoaded && productInfo.quantity > 0) {
      productDispatch({ type: "setPriceLoaded", payload: false });
      const newQueryString = makeQueryString();
      getUpdatedPrice(newQueryString);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productInfo]);

  return (
    <ProductsContext.Provider value={{ productState, productDispatch }}>
      {!pageLoaded ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Container maxWidth="xl">
          <Mobile></Mobile>
          <Default>
            <Grid container spacing={6} sx={{ marginBottom: "1rem" }}>
              <Grid item xs={5} sx={{ borderRight: "2px solid #e3e3e3" }}>
                <Stack>
                  <img
                    src={CharmsImage}
                    alt="Selected Product"
                    className="selected-product"
                  />
                  {charmShape && charmStyle && (
                    <DetailTable data={productDetails} />
                  )}
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack spacing={1} sx={{ marginBottom: ".5rem" }}>
                  <Typography variant="h4">Charms</Typography>
                  <Typography>
                    Select a Charm Shape to start placing your order!
                  </Typography>
                  <Stack direction="row" spacing={1}>
                    {charmShape &&
                      charmStyle &&
                      icons &&
                      icons.map((icons, key) => (
                        <Typography key={icons} className="icons">
                          {functions.getIcons(icons)}
                        </Typography>
                      ))}
                  </Stack>
                </Stack>
                <Stack spacing={1}>
                  <Stack>
                    <Typography
                      sx={{ fontWeight: "700", paddingBottom: ".3rem" }}
                    >
                      Charm Shape
                    </Typography>
                    <Select
                      value={charmShape === null ? "None" : charmShape}
                      size="small"
                      sx={{ width: "100%" }}
                      onChange={(e) => {
                        setCharmShape(e.target.value);
                        setCharmStyle(null);
                        setFilter([
                          {
                            name: "CharmShape",
                            values: [e.target.value],
                          },
                        ]);
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            border: "1px solid #939598",
                            borderRadius: "0",
                            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                          },
                        },
                      }}
                    >
                      <MenuItem value="None">
                        <em>Select...</em>
                      </MenuItem>
                      {charmShapeOptions &&
                        charmShapeOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                    </Select>
                  </Stack>
                  {charmShape && (
                    <Stack>
                      <Typography
                        sx={{ fontWeight: "700", paddingBottom: ".3rem" }}
                      >
                        Charm Style
                      </Typography>
                      <Select
                        value={charmStyle === null ? "None" : charmStyle}
                        size="small"
                        sx={{ width: "100%" }}
                        onChange={(e) => {
                          setCharmStyle(e.target.value);
                        }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1px solid #939598",
                              borderRadius: "0",
                              maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                            },
                          },
                        }}
                      >
                        <MenuItem value="None">
                          <em>Select...</em>
                        </MenuItem>
                        {charmStyles &&
                          charmStyles.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                      </Select>
                    </Stack>
                  )}
                  {charmShape && charmStyle && (
                    <Divider flexItem sx={{ paddingTop: "1rem" }} />
                  )}
                  {charmShape &&
                    charmStyle &&
                    productFields &&
                    productFields.map((field) => {
                      if (field.name === "material") {
                        return (
                          <Material
                            field={field}
                            key={field.name}
                            isMill={props.isMill}
                          />
                        );
                      } else if (field.name === "thickness") {
                        return (
                          <Thickness
                            field={field}
                            key={field.name}
                            isMill={props.isMill}
                          />
                        );
                      } else if (field.name === "quantity") {
                        return (
                          <Quantity
                            field={field}
                            key={field.name}
                            isMill={props.isMill}
                          />
                        );
                      } else {
                        return "";
                      }
                    })}
                  {charmShape && charmStyle && (
                    <Divider flexItem sx={{ paddingTop: "1rem" }} />
                  )}
                  {charmShape &&
                    charmStyle &&
                    productTreatments &&
                    productTreatments.map((treat) => {
                      return <TreatmentField field={treat} key={treat.label} />;
                    })}
                  {charmShape && charmStyle && <SpecialInstructions />}
                </Stack>
              </Grid>
              <Grid item xs={3}>
                {charmShape && charmStyle && <Price />}
                {advertisement && (
                  <DomLink
                    to={{
                      pathname: `${advertisement.alternativeText}`,
                      state: {
                        recentlyViewed: JSON.parse(
                          storage.getSessionStorageItem(
                            "hsRecentlyViewedProducts"
                          )
                        ),
                      },
                    }}
                  >
                    <img
                      style={{ marginTop: "4rem" }}
                      src={`${frontImageUrl}${advertisement.url}`}
                      width="100%"
                      alt="advertisement"
                    />
                  </DomLink>
                )}
              </Grid>
            </Grid>
            {charmShape && charmStyle && (
              <>
                <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                  Compatible Products
                </Typography>
                {compatibleProducts && (
                  <HorizontalScrollList
                    loadedStyles={compatibleProducts}
                    compatible={true}
                  />
                )}
                <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                  Related Items
                </Typography>
                {relatedProducts && (
                  <HorizontalScrollList
                    loadedStyles={relatedProducts}
                    related={true}
                  />
                )}
                <div>
                  <TechnicalArticles productGroup={productGroup} />
                  <CustomerTestimonials />
                </div>
                <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                  Recently Viewed
                </Typography>
                {props.RecentlyViewed && (
                  <HorizontalScrollList loadedStyles={props.RecentlyViewed} />
                )}
              </>
            )}
            {metalColumns && (
              <>
                <Divider flexItem />
                <Grid container spacing={20} justifyContent="center">
                  <Grid item xs={4}>
                    <Typography variant="staticText">
                      <ReactMarkdown remarkPlugins={[remarkGfm]}>
                        {metalColumns.left}
                      </ReactMarkdown>
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="staticText">
                      <ReactMarkdown remarkPlugins={[remarkGfm]}>
                        {metalColumns.middle}
                      </ReactMarkdown>
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="staticText">
                      <ReactMarkdown remarkPlugins={[remarkGfm]}>
                        {metalColumns.right}
                      </ReactMarkdown>
                    </Typography>
                  </Grid>
                </Grid>
              </>
            )}
            {strapiChart && (
              <>
                <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                  Product Series
                </Typography>
                {TopText && (
                  <Typography variant="staticText">
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>
                      {TopText}
                    </ReactMarkdown>
                  </Typography>
                )}
                {ChartSizeSmall ? (
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid item xs={6} className="center">
                      <img
                        src={`${frontImageUrl}${strapiChart.data.attributes.url}`}
                        width="100%"
                        alt="banner"
                      />
                    </Grid>
                    <Grid item xs={6} className="center">
                      <img src={FillerImage} alt="filler for small table" />
                    </Grid>
                  </Grid>
                ) : (
                  <img
                    src={`${frontImageUrl}${strapiChart.data.attributes.url}`}
                    width="100%"
                    alt="banner"
                  />
                )}
                {BottomText && (
                  <Typography variant="staticText">
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>
                      {BottomText}
                    </ReactMarkdown>
                  </Typography>
                )}
              </>
            )}
          </Default>
        </Container>
      )}
    </ProductsContext.Provider>
  );
}
